import {fectServiceApi} from '../../lib/fetchServiceApi'
import {isEmpty} from '../../lib/Utils'

export async function generateClientToken() {
  return new Promise((resolve, reject)=>{
    let params = {};
    let druIdToken = localStorage.getItem('druid_pulse_token');
    let lastTimeToken = localStorage.getItem('druid_pulse_tokentime');
    let timestamp = new Date().getTime();

    
    if(isEmpty(druIdToken) || (timestamp - lastTimeToken) > 180 * 1000 ){
      fectServiceApi('/api/dru-id/generate-token', params)
      .then((response)=>{
        localStorage.setItem('druid_pulse_token', response?.token);
        localStorage.setItem('druid_pulse_tokentime', timestamp);
        resolve(response?.token);
      })
    }else{
      resolve(druIdToken);
    }
  })
}